module.exports = __webpack_public_path__ + "img/mobHand.7a78c400.png";